import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { auth, onAuthStateChanged } from './firebase-functions/config.js';
import { StudentNavbar } from './components/student/StudentNavbar.jsx';
import Login from './components/auth/Login.jsx';

import './App.css'; // Import the core CSS
import './style/auth.css'; // Import the custom CSS
import 'react-toastify/dist/ReactToastify.css';
import { Account } from './components/auth/StudentAccount/Account.jsx';

import { Suspense, lazy } from 'react';

import {
  getDemoReaderDocument,
  getDocument,
  updateDocument,
} from './firebase-functions/database.js';
import { toast } from 'react-toastify';

import { NotFound } from './components/utils/NotFound.jsx';
import { PhraseGame } from './components/student/phrases/PhraseGame.jsx';

import { Bingo } from './components/bingo/Bingo.jsx';
import { TwentyFour } from './components/24Game/TwentyFour.jsx';
import { Dragon } from './components/student/Dragon.jsx';

import { ReadingCelebration } from './components/student/readingCelebration/ReadingCelebration.jsx';
import { useBookReadListener } from './firebase-functions/realTime.js';
import { MarketPlace } from './components/marketPlace/MarketPlace.jsx';
import { ReadingQuest } from './components/student/quest/ReadingQuest.jsx';
import { StickerBook } from './components/stickerBook/StickerBook.jsx';
import { ScratchCard } from './components/scratchCard/ScratchCard.jsx';
import FuturisticLoader from './components/FuturisticLoader.jsx';
import { RacebarContainer } from './components/student/racebar/RaceBarContainer.jsx';

const ReadingRoom = lazy(
  () => import('./components/student/readingRoom/ReadingRoom.jsx'),
);
const StudentDashboard = lazy(
  () => import('./components/student/StudentDashboard.jsx'),
);

const App = () => {
  const [user, setUser] = useState({});
  const [userInfo, setUserInfo] = useState();
  const [studentInfo, setStudentInfo] = useState();

  const [readerProfile, setReaderProfile] = useState();
  const [competitionInfo, setDefaultCompetitionInfo] = useState();
  const [role, setRole] = useState('');

  const [celebration, setCelebration] = useState(null);
  const [celebrationTheme, setCelebrationTheme] = useState(null);

  const newRead = useBookReadListener(auth?.currentUser?.uid);
  const [visibleRead, setVisibleRead] = useState(null);
  const [newLocalRead, setNewLocalRead] = useState(null); //for try it on the announcements

  const [showOverlay, setShowOverlay] = useState();

  useEffect(() => {
    onAuthStateChanged(auth, (u) => {
      if (u?.uid) {
        getDocument('users', u?.uid).then((res) => {
          if (res.success) {
            setUserInfo(res.data);
          } else {
            toast.error(res.message);
          }
        });
        getDocument('students', auth.currentUser.uid).then((res) => {
          if (res.success) {
            setStudentInfo(res.data);
          } else {
          }
        });
      } else {
        setRole('guest');
      }
    });
  }, []);

  useEffect(() => {
    if (!auth) {
      return;
    }

    if (userInfo?.role === 'student') {
      getDemoReaderDocument(auth.currentUser.uid).then((res) => {
        if (!res.success) {
          return;
        }

        setReaderProfile(res.message);

        setRole('student');

        if (res.message.scratchCard) {
          if (res.message.scratchCard === 'none') {
            return;
          }

          if (res.message.scratchCard === 'gold') {
            setShowOverlay('gold');
          } else if (res.message.scratchCard === 'silver') {
            setShowOverlay('silver');
          } else if (res.message.scratchCard === 'bronze') {
            setShowOverlay('bronze');
          }

          let currentReaderProfile = res.message;
          currentReaderProfile.scratchCard = 'claiming';

          updateDocument(
            'demoReaders',
            res.message.id,
            currentReaderProfile,
            auth.currentUser,
          ).then((resUpdate) => {
            if (!resUpdate.success) {
              toast.error('Something went wrong');
              return;
            }
          });
        }
      });
    }
  }, [userInfo]);

  useEffect(() => {
    // Simulate event from backend
    const timer = setTimeout(() => {
      setCelebration({ name: 'Alice', book: 'The Magic Treehouse' });
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (newRead) {
      if (
        studentInfo &&
        studentInfo?.annoncementSetting &&
        studentInfo.annoncementSetting.value === false
      ) {
        return;
      }

      if (
        parseInt(localStorage.getItem('lastAnnouncement')) !== newRead.timestamp
      ) {
        setVisibleRead(newRead);
        setCelebrationTheme(newRead?.theme || 'default');
        setTimeout(() => {
          localStorage.setItem('lastAnnouncement', newRead.timestamp);
        }, 5000);

        const timer = setTimeout(() => setVisibleRead(null), 60000); // hide after 6s
        return () => clearTimeout(timer);
      }
    }
  }, [newRead]);

  // for market place theme trials
  // useEffect(() => {
  //   if (!newLocalRead) return;

  //   setCelebrationTheme(newLocalRead?.theme || 'default');

  //   const timer = setTimeout(() => setVisibleRead(null), 60000); // hide after 6s

  //   return () => clearTimeout(timer);
  // }, [newLocalRead]);

  return (
    <BrowserRouter>
      <StudentNavbar role={role} />
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          {role === 'guest' && <Route path='*' element={<Login />} />}

          {role === 'student' && (
            <Route>
              <Route
                path='/'
                element={
                  <StudentDashboard
                    user={user}
                    setUser={setUser}
                    studentInfo={studentInfo}
                    readerProfile={readerProfile}
                    competitionInfo={competitionInfo}
                    setDefaultCompetitionInfo={setDefaultCompetitionInfo}
                    setNewLocalRead={setNewLocalRead}
                  />
                }
              />
              <Route
                path='/dashboard'
                element={
                  <StudentDashboard
                    user={user}
                    setUser={setUser}
                    studentInfo={studentInfo}
                    readerProfile={readerProfile}
                    competitionInfo={competitionInfo}
                    setDefaultCompetitionInfo={setDefaultCompetitionInfo}
                    setNewLocalRead={setNewLocalRead}
                  />
                }
              />

              <Route
                path='/race'
                element={
                  <RacebarContainer
                    studentInfo={studentInfo}
                    readerProfile={readerProfile}
                  />
                }
              />

              <Route
                path='/account'
                element={
                  <Account
                    user={user}
                    setUser={setUser}
                    readerProfile={readerProfile}
                    studentInfo={studentInfo}
                    competitionInfo={competitionInfo}
                  />
                }
              />
              <Route path='/phrases' element={<PhraseGame />} />

              <Route
                path='/reading-room/levels'
                element={
                  <ReadingRoom
                    toggleIsLevel={true}
                    user={user}
                    setUser={setUser}
                    readerProfile={readerProfile}
                    studentInfo={studentInfo}
                  />
                }
              />

              <Route
                path='/bingo'
                element={<Bingo readerProfile={readerProfile} />}
              />

              <Route
                path='/quests'
                element={<ReadingQuest readerId={readerProfile.id} />}
              />

              {/* <Route path='vocab-mission' element={<FuturisticLoader />} /> */}

              {/* <Route path="/24-game" element={<TwentyFour />} />
              <Route path="/dragon" element={<Dragon />} /> */}
            </Route>
          )}
          <Route
            path='/sticker-book'
            element={<StickerBook readerProfile={readerProfile} />}
          />

          <Route path='*' element={<NotFound />} />
        </Routes>

        {visibleRead && (
          <ReadingCelebration
            name={visibleRead.name}
            book={visibleRead.book}
            theme={celebrationTheme}
          />
        )}

        {showOverlay && readerProfile && (
          <ScratchCard
            onClose={() => setShowOverlay(null)}
            readerId={readerProfile.id}
            tier={showOverlay}
          />
        )}
      </Suspense>
    </BrowserRouter>
  );
};

export default App;
